// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9105b5b3","455":"0c2864c0"}[chunkId] + ".chunk.js";
};